import { Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAuth } from '../Context/AuthContext';

const PrivateRoute = ({isAuthenticated, element}) => {
  return isAuthenticated ? element : <Navigate to="/login"/>;
};

export default PrivateRoute;